import React from "react"
import PCMViewQuestion from "./Component/PCMViewQuestion/PCMViewQuestion"
// import CCMAdminPatient from "../CCMAdminPatient/CCMAdminPatient"

const PCMViewCare = () => <PCMViewQuestion />

export default PCMViewCare
